import React from "react"
import { Helmet } from "react-helmet"

const Seo = props => {
  const data = {
    lang: `en`,
    title: props.seoProps.title
      ? props.seoProps.title
      : ` default title SUPERCONTINENT`,
    description: props.seoProps.description
      ? props.seoProps.description
      : `SUPERCONTINENT is a digital vfx company that strives to achieve highest visual diversity on all screens and spaces.`,
    image: props.seoProps.image && props.seoProps.image.localFile.publicURL,
  }

  return (
    <Helmet
      htmlAttributes={{
        lang: `${data.lang}`,
      }}
    >
      <title>{data.title}</title>
      <meta name="description" content={data.description} />
      <meta
        itemprop="name"
        itemscope
        itemtype="http://schema.org/WebPage"
        content={data.title}
      />
      <meta
        itemprop="description"
        itemscope
        itemtype="http://schema.org/WebPage"
        content={data.description}
      />
      <meta
        itemprop="image"
        itemscope
        itemtype="http://schema.org/WebPage"
        content={data.image}
      />
      <meta property="og:title" content={data.title} />
      <meta property="og:image" content={data.image} />
      <meta name="twitter:title" content={data.title} />
      <meta name="twitter:description" content={data.description} />
      <meta name="twitter:image:src" content={data.image} />
    </Helmet>
  )
}

export default Seo
